import AutoSubmit from "@stimulus-components/auto-submit"

// Extends the Stimulus AutoSubmit controller to display a waiting spinner
// while the form is being auto-submitted.
//
// Optionally provide a `spinner` target to control which element is shown.
// When no target is present a default spinner is created and appended to the
// form. The spinner is hidden again once the Turbo submission completes.
export default class extends AutoSubmit {
  static targets = ["spinner"]

  connect() {
    super.connect()
    this.hideSpinner = this.hideSpinner.bind(this)
    this.element.addEventListener("turbo:submit-end", this.hideSpinner)
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-end", this.hideSpinner)
    this.removeDefaultSpinner()
  }

  submit() {
    this.showSpinner()
    super.submit()
  }

  showSpinner() {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.remove("hidden")
    } else {
      this.defaultSpinner().classList.remove("hidden")
    }
  }

  hideSpinner() {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.add("hidden")
    } else {
      this.removeDefaultSpinner()
    }
  }

  defaultSpinner() {
    if (!this._defaultSpinner) {
      this.ensureRelativePositioning()

      this._defaultSpinner = document.createElement("div")
      this._defaultSpinner.className =
        "absolute inset-0 z-10 flex items-center justify-center bg-white/60"
      this._defaultSpinner.setAttribute("role", "status")
      this._defaultSpinner.setAttribute("aria-label", "Submitting")

      const spinner = document.createElement("div")
      spinner.className =
        "inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"
      this._defaultSpinner.appendChild(spinner)

      this.element.appendChild(this._defaultSpinner)
    }
    return this._defaultSpinner
  }

  ensureRelativePositioning() {
    const position = getComputedStyle(this.element).position
    if (position === "static") {
      this._addedRelativePositioning = true
      this.element.classList.add("relative")
    }
  }

  removeDefaultSpinner() {
    if (this._defaultSpinner) {
      this._defaultSpinner.remove()
      this._defaultSpinner = null
    }
    if (this._addedRelativePositioning) {
      this.element.classList.remove("relative")
      this._addedRelativePositioning = false
    }
  }
}
